import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a table view for managerial reports.
 * @extends JetView
 */
export default class tableInformeGerencialView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        return {
            rows: [
                {
                    cols: [
                        {
                            view: 'treetable', // Treetable component
                            id: 'treetable', // Unique identifier for the treetable
                            css: 'webix_header_border webix_data_border webix_footer_border informeGerencial', // CSS classes for styling
                            select: true, // Enable row selection
                            height: 0, // Initial height
                            autoConfig: true, // Automatically configure columns
                            columns: [], // Columns configuration
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The treetable instance.
     */
    init(grid) {
        grid = $$('treetable'); // Get the treetable instance
        this.on(this.app, 'filter', (filterData) => {
            // Listen for filter events
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append simple filters to query string
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        if (object[i][0] === 'Date') {
                            // Specific handling for 'Date'
                            var d = new Date(object[i][1]); // Create date object
                            var dateFrom =
                                'DateFrom=' +
                                d.getFullYear() +
                                '-' +
                                ('00' + (d.getMonth() + 1)).slice(-2) +
                                '-' +
                                '01'; // Format date for query
                            string1 = string1 + '&' + dateFrom; // Append to query string
                        } else {
                            if (object[i][0] === 'Date2') {
                                // Specific handling for 'Date2'
                                var d = new Date(object[i][1]); // Create date object
                                var ud = new Date(object[i][1].getFullYear(), object[i][1].getMonth() + 1, 0); // Get last day of the month
                                var dateFrom =
                                    'DateTo=' +
                                    d.getFullYear() +
                                    '-' +
                                    ('00' + (d.getMonth() + 1)).slice(-2) +
                                    '-' +
                                    ('00' + ud.getDate()).slice(-2); // Format date for query
                                string1 = string1 + '&' + dateFrom; // Append to query string
                            }
                        }
                    }
                }
            }
            string1 = string1 + '&Report=7'; // Append report type to query string
            webix
                .ajax() // Perform AJAX request
                .headers({
                    'Content-type': 'application/json', // Set content type
                })
                .get(
                    devConfig.geturlApi() + 'Financial/GetControlFiscal?' + string1, // Construct URL with query string
                    {
                        success: function (text, data, XmlHttpRequest) {
                            // Handle successful response
                            var resp = JSON.parse(text); // Parse JSON response
                            grid.clearAll(); // Clear existing data in the grid
                            grid.config.columns = [];
                            grid.refreshColumns();
                            if (
                                !resp.HasError && // Check for errors in response
                                resp.Data != undefined &&
                                resp.Data.Columns != undefined &&
                                resp.Data.Columns.length > 0
                            ) {
                                grid.parse(resp.Data.Columns); // Populate grid with new data
                                for (var i in grid.config.columns) {
                                    // Disable sorting for columns
                                    grid.config.columns[i].sort = false;
                                    grid.adjustColumn(
                                        grid.config.columns[i].id,
                                        'all', // Adjust column width
                                    );
                                }
                                grid.attachEvent(
                                    'onResize', // Attach resize event
                                    function (width, height) {
                                        for (var i in grid.config.columns) {
                                            grid.adjustColumn(
                                                grid.config.columns[i].id,
                                                'all', // Adjust column width on resize
                                            );
                                        }
                                    },
                                );
                            }
                        },
                    },
                );
            $$('filterPopup').hide(); // Hide filter popup after applying filter
        });
    }
}

// FILE DOCUMENTED
